import { getEnvVar } from 'util/env';

export function isProduction(): boolean {
  return import.meta.env.VITE_APP_ENV === 'production';
}

export type Environment =
  | 'local'
  | 'staging'
  | 'production'
  | 'test'
  | 'unknown';

export function getFrontendEnvironment() {
  return getEnvVar('APP_ENV');
}

export function getDatabaseEnvironment(databaseName: string) {
  if (databaseName === 'testbackend') {
    return 'test';
  }
  if (databaseName === 'gaugebackenddocker') {
    return 'local';
  }
  if (databaseName === 'gaugebackendbeta') {
    return 'staging';
  }
  if (databaseName === 'gauge_live') {
    return 'production';
  }
  return 'unknown';
}
